/**
 * Retorna `true` se `x` for maior que `y`.
 *
 * @param {number|string} x
 * @param {number|string} y
 * @returns {boolean}
 */
export function gt(x, y) {
  return Number(x) > Number(y);
}
